import React, { useState, useEffect } from 'react';
import { TagOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Popover, Select, Input, Button } from 'antd';

import style from './index.less';

const { Option, OptGroup } = Select;
const validatorRule = {
  validator: (rule, value, callback) => {
    if (value && value.length > 20) {
      callback('需小于 20 个字符');
    }
    callback();
  }
};
const InsertTag = props => {
  const [formVisible, setFormVisible] = useState(false);
  const { insert, form, options } = props;
  const { getFieldDecorator } = form;
  const handleSave = () => {
    form.validateFields((err, values) => {
      if (!err) {
        insert({ text: values.defaultText, label: values.variate });
        setFormVisible(false);
      }
    });
  };

  useEffect(() => {
    form.resetFields();
  }, [formVisible]);
  return (
    <div className="replace-word">
      <Popover
        open={formVisible}
        trigger="click"
        onOpenChange={val => setFormVisible(val)}
        content={
          <Form className={style['tool-form']}>
            <Form.Item label="替换变量">
              {getFieldDecorator('variate', {
                initialValue: options[0]?.options[0]?.value || '',
                rules: [{ required: true, message: '不能为空' }]
              })(
                <Select showSearch={true}>
                  {options.map(val => {
                    const { label, options } = val;
                    return (
                      <OptGroup label={label} key={label}>
                        {options.map(val => {
                          const { label, value } = val;
                          return (
                            <Option value={value} key={value}>
                              {label}
                            </Option>
                          );
                        })}
                      </OptGroup>
                    );
                  })}
                </Select>
              )}
            </Form.Item>
            <Form.Item label="默认值">
              {getFieldDecorator('defaultText', {
                initialValue: '',
                rules: [{ required: true, message: '不能为空' }, validatorRule]
              })(<Input placeholder="变量为空的默认值" />)}
            </Form.Item>
            <Button type="primary" onClick={handleSave}>
              添加
            </Button>
          </Form>
        }>
        <button
          type="button"
          className="control-item button upload-button"
          data-title="插入变量"
          onClick={() => setFormVisible(true)}>
          <TagOutlined />
        </button>
      </Popover>
    </div>
  );
};

export default Form.create('tag')(InsertTag);
